<template>
  <div class="card">
    <el-form :model="frm" :rules="rules" status-icon ref="frm" label-width="140px" class="demo-form">
        <div class="card-body">
          <div class="header right gray">
            회원가입일 <span class="number">{{formatterDate(frm.join_dt)}}</span><template v-if="frm.use_yn === 'N'"> | 회원탈퇴일 <span class="number">{{formatterDate(frm.leave_date)}}</span></template> | 마지막 로그인 <span class="number">{{formatterDate(frm.last_login_date)}}</span>
          </div>

          <div class="media">
            <div class="mr-3">
              <el-upload class="avatar-uploader" action="/api/file/upload"
                :headers="fileHeaders"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <div class="media-body">
              <h5>{{frm.name}} <span class="badge rose align-middle">{{frm.user_type_name}}</span><span v-if="frm.use_yn === 'N'" class="badge red align-middle">탈퇴회원</span></h5>
            </div>
          </div>

        </div>
        <div class="card-body gray">
          <h5>개인</h5>
          <p class="small description">기본정보를 입력해 주세요.</p>
          <hr />
          <div class="card-form">
          <!-- <el-form-item label="구분" prop="user_type">
            <el-radio v-model="frm.user_type" label="S">학생</el-radio>
            <el-radio v-model="frm.user_type" label="T">선생님</el-radio>
            <el-radio v-model="frm.user_type" label="A">관리자</el-radio>
          </el-form-item> -->

            <el-form-item label="아이디" prop="id">
              {{frm.id}}
              <!-- <el-input v-model="frm.id" :disabled="true"></el-input> -->
            </el-form-item>
            <el-form-item label="이름" prop="name">
              <el-input v-model.trim="frm.name" placeholder="이름"></el-input>
            </el-form-item>
            <el-form-item label="생년월일" required class="select-group">
              <el-col :span="8">
                <el-form-item prop="birthday_yyyy">
                  <el-select v-model="frm.birthday_yyyy" placeholder="년" >
                    <el-option v-for="y in yearCount" :key="y" :label="`${y + startYear} 년`" :value="y + startYear">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="birthday_mm">
                  <el-select v-model="frm.birthday_mm" placeholder="월">
                    <el-option v-for="m in 12" :key="m" :label="`${m} 월`" :value="getDateValue(m)">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item prop="birthday_dd">
                  <el-select v-model="frm.birthday_dd" placeholder="일">
                    <el-option v-for="d in getDays" :key="d" :label="`${d} 일`" :value="getDateValue(d)">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="학교" prop="school_name" v-if="frm.user_type === 'S'">
              <el-input v-model.trim="frm.school_name"></el-input>
            </el-form-item>
            <el-form-item label="클래스" prop="user_class" v-if="frm.user_type === 'S'">
              <el-select v-model="frm.user_class" multiple placeholder="선택하세요." style="width: 100%;">
                <el-option v-for="item in classData" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="사용여부">
              <el-switch v-model="isUse" active-text="사용" inactive-text="미사용"></el-switch>
            </el-form-item> -->
          </div>

          <h5>전화번호</h5>
          <p class="small description">기본정보를 입력해 주세요.</p>
          <hr />
          <div class="card-form">
            <el-form-item label="전화번호" prop="phone">
              <el-input v-model.trim="frm.phone" placeholder="'-' 를 빼고 입력하십시오" @change="autoHypenPhone('phone')"></el-input>
            </el-form-item>
            <el-form-item label="알림 유형" prop="msg_type">
              <el-radio-group v-model="frm.msg_type" class="stone-radio-btton">
                <el-radio-button label="K">카카오톡</el-radio-button>
                <el-radio-button label="S">SMS</el-radio-button>
                <el-radio-button label="N">수신거부</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="보호자 전화번호" prop="parent_phone">
              <el-input v-model.trim="frm.parent_phone" placeholder="'-' 를 빼고 입력하십시오" @change="autoHypenPhone('parent_phone')"></el-input>
            </el-form-item>
          </div>

          <h5>메모</h5>
          <p class="small description">기본정보를 입력해 주세요.</p>
          <hr />
          <div class="card-form textarea">
            <el-form-item label="메모" prop="memo">
              <el-input type="textarea" :rows="3" v-model.trim="frm.memo" placeholder="메모를 입력하세요."></el-input>
            </el-form-item>
          </div>

        </div>

      <div class="card-body text-right">
        <el-button @click="goList">취소</el-button>
        <el-button type="warning" @click="initPassword" v-if="frm.use_yn === 'Y'">비밀번호 초기화</el-button>
        <el-button type="danger" @click="deleteUser">삭제</el-button>
        <el-button type="primary" @click="submitForm('frm')" v-if="frm.use_yn === 'Y'">저장</el-button>
      </div>

    </el-form>
  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M080103',
  mixins: [common.mixins],
  data () {
    return {
      isUse: true,
      frm: {
        user_info_seq: 0,
        id: '',
        pw: '',
        name: '',
        phone: '',
        parent_phone: '',
        school_name: '',
        user_type: 'S',
        user_type_name: '',
        use_yn: 'Y',
        file_seq: 0,
        birthday: '',
        join_dt: '',
        stat: '',
        auth_grp: 'S',
        memo: '',
        birthday_yyyy: '',
        birthday_mm: '',
        birthday_dd: '',
        last_login_date: '',
        user_class: [],
        msg_type: '',
        leave_date: ''
      },
      classData: [],
      fileHeaders: {
        Authorization: '',
        Seq: 0,
        Table: 'USER'
      },
      yearCount: 0,
      startYear: 1965 - 1,
      imageUrl: '',
      rules: {
        id: [
          { required: true, message: '사용자 아이디를 입력하십시오.', trigger: 'blur' },
          { min: 3, max: 15, message: '최소 3자 이상 최대 12자까지 입력하십시오.' }
        ],
        name: [
          { required: true, message: '사용자 이름을 입력하십시오.', trigger: 'blur' },
          { min: 2, max: 20, message: '최소 2자 이상 최대 20자까지 입력하십시오.' }
        ],
        phone: [
          { required: true, message: '전화번호를 입력하십시오.', trigger: 'blur' },
          { type: 'string', pattern: /^[0-9]/, message: '숫자만 가능합니다.' },
          { type: 'string', pattern: /^01([0|1|6|7|8|9]?)-?(\d{3,4})-?(\d{4})$/, message: '전화번호 형식에 맞지 않습니다.' }
        ],
        parent_phone: [
          { required: false, message: '보호자 전화번호를 입력하십시오.', trigger: 'blur' },
          { type: 'string', pattern: /^[0-9]/, message: '숫자만 가능합니다.' },
          { type: 'string', pattern: /^(?:\+?\d{0,3}[)|-]?\d{0,3}-?)\d{3,4}-?\d{4}$/, message: '전화번호 형식에 맞지 않습니다.' }
        ],
        birthday_yyyy: [
          { required: true, message: '생년월일(년도)을 입력하십시오.', trigger: 'change' }
        ],
        birthday_mm: [
          { required: true, message: '생년월일(월)을 입력하십시오.', trigger: 'change' }
        ],
        birthday_dd: [
          { required: true, message: '생년월일(일)을 입력하십시오.', trigger: 'change' }
        ],
        memo: [
          { required: false, message: '메모를 입력하십시오.', trigger: 'blur' },
          { max: 200, message: '최대 200자까지 입력하십시오.' }
        ],
        school_name: [
          { required: false, message: '학교를 입력하세요', trigger: 'blur' },
          { max: 20, message: '최대 20자까지 입력하십시오.' }
        ],
        msg_type: [
          { required: true, message: '알림 유형을 선택하십시오.', trigger: 'change' }
        ]
      }
    }
  },
  beforeCreate () {
  },
  created () {
    const userInfoSeq = this.$route.params.user_info_seq
    if (userInfoSeq && userInfoSeq !== 0) {
      common.axios.post('/class/list')
        .then(response => {
          const result = response.data
          result.forEach(c => {
            this.classData.push({label: c.class_name, value: c.class_seq, disabled: c.use_yn === 'N'})
          })
        })
      this.$nextTick(() => {
        this.loadInfo(userInfoSeq)
      })
    } else {
      this.$router.push({name: 'M080101'})
    }
  },
  computed: {
    getDays: function () {
      return this.frm.birthday_mm !== '' ? this.getMonthLastDay(this.frm.birthday_yyyy + this.frm.birthday_mm) : 31
    }
  },
  mounted () {
    this.fileHeaders.Authorization = this.$store.getters.access_token
    const today = new Date()
    this.yearCount = (this.startYear - today.getFullYear()) * -1
  },
  methods: {
    submitForm: function (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.frm.birthday = this.frm.birthday_yyyy + this.frm.birthday_mm + this.frm.birthday_dd
          this.frm.phone = this.getOnlyNumber(this.frm.phone)
          this.frm.parent_phone = this.getOnlyNumber(this.frm.parent_phone)
          common.axios.put('/user', this.frm)
            .then(response => {
              if (response.data.status === 1) {
                this.$message('수정하였습니다.')
                setTimeout(() => {
                  this.$router.push({name: 'M080101', params: {isSearch: true}})
                }, 1000)
              }
            })
        } else {
          this.$message.error('수정 내용을 확인하십시오.')
          return false
        }
      })
    },
    resetForm: function (formName) {
      this.$refs[formName].resetFields()
    },
    handleAvatarSuccess (res, file) {
      if (res.status === 1 && res.file_seq !== undefined) {
        this.frm.file_seq = res.file_seq
        this.imageUrl = URL.createObjectURL(file.raw)
      }
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('사진은 jpg, png 파일만 업로드 가능합니다.')
      }
      if (!isLt2M) {
        this.$message.error('최대 2MB까지 가능합니다.')
      }
      return isJPG && isLt2M
    },
    getDateValue (value) {
      return (value < 10 ? '0' : '') + value
    },
    goList () {
      this.$router.push({name: 'M080101'})
    },
    loadInfo (userInfoSeq) {
      common.axios.get('/user/load/' + userInfoSeq)
        .then(response => {
          const result = response.data
          // console.log('result : ', result)
          Object.keys(this.frm).forEach(key => {
            if (key !== 'phone' && key !== 'parent_phone' && key !== 'user_class') {
              this.frm[key] = this.isEmpty(result[key]) ? '' : result[key]
            }
          })
          this.frm.birthday_yyyy = result.birthday.substr(0, 4)
          this.frm.birthday_mm = result.birthday.substr(4, 2)
          this.frm.birthday_dd = result.birthday.substr(6, 2)
          this.frm.phone = this.formatterPhone(result.phone)
          this.frm.parent_phone = this.formatterPhone(result.parent_phone)
          if (result.download_url) {
            this.imageUrl = result.download_url
            this.frm.file_seq = 0
          }
          const userClass = []
          result.user_class.map(x => {
            userClass.push(x.class_seq)
          })
          this.frm.user_class = userClass
        })
    },
    autoHypenPhone (elem) {
      const value = this.getOnlyNumber(this.frm[elem])
      let tmp = ''
      if (value.length < 4) {
        tmp = value
      } else if (value.length < 7) {
        tmp += value.substr(0, 3)
        tmp += '-'
        tmp += value.substr(3)
      } else if (value.length < 11) {
        tmp += value.substr(0, 3)
        tmp += '-'
        tmp += value.substr(3, 3)
        tmp += '-'
        tmp += value.substr(6)
      } else {
        tmp += value.substr(0, 3)
        tmp += '-'
        tmp += value.substr(3, 4)
        tmp += '-'
        tmp += value.substr(7)
      }
      this.frm[elem] = tmp
    },
    deleteUser () {
      this.$confirm('해당 사용자를 삭제 하시겠습니까?', '', {
      }).then(() => {
        common.axios.delete('/user', {data: {user_info_seq: this.frm.user_info_seq}})
          .then(response => {
            const result = response.data
            if (result.status === 1) {
              this.$message('사용자가 삭제되었습니다.')
              setTimeout(() => {
                this.$router.push({name: 'M080101', params: {isSearch: true}})
              }, 1000)
            } else {
              this.$message.warning(result.message)
            }
          })
      }).catch(() => {})
    },
    initPassword () {
      this.$confirm('비밀번호를 초기화 하시겠습니까?', '', {
      }).then(() => {
        common.axios.put('/user/init/password/', {user_info_seq: this.frm.user_info_seq})
          .then(response => {
            const result = response.data
            if (result.status === 1) {
              this.$message('비밀번호가 초기화 되었습니다.')
            } else {
              this.$message.warning(result.message)
            }
          })
      }).catch(() => {})
    }
  },
  watch: {
    isUse: function (value) {
      this.frm.use_yn = value ? 'Y' : 'N'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/M080103.vue